import { useAuditDetailDispatch } from './audit-detail-context';
import PortalAppService from '../../../application/platform/portal-app-service';

export function useAuditDetailController() {
  const dispatch = useAuditDetailDispatch();

  const loadDetail = async (id: number) => {
    dispatch({ type: 'LOAD_START' });
    try {
      const response = await PortalAppService.requestAuditDetail(id);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: 'LOAD_ERROR', payload: 'Erro ao carregar detalhes da auditoria.' });
    }
  };

  return { loadDetail };
}
